export const metricOptions = {
  growth: [
    {
      value: 'downloads',
      label: 'Downloads',
      buttonLabel: 'Downloads',
    },
    {
      value: 'total_revenue',
      label: 'Total Revenue',
      buttonLabel: 'Total Revenue',
    },
    {
      value: 'iap_revenue',
      label: 'IAP Revenue',
      buttonLabel: 'IAP Revenue',
    },
  ],
  engagement: [
    {
      value: 'dau',
      label: 'Daily Active Users (DAU)',
      buttonLabel: 'Daily Active Users (DAU)',
      titleLabel: 'DAU',
    },
    {
      value: 'mau',
      label: 'Monthly Active Users (MAU)',
      buttonLabel: 'Monthly Active Users (MAU)',
      titleLabel: 'MAU',
    },
    {
      value: 'sessions',
      label: 'Total Number of Sessions',
      buttonLabel: 'Total Number of Sessions',
    },
    {
      value: 'total_time_spent',
      label: 'Total Time Spent',
      buttonLabel: 'Total Time Spent',
    },
  ],
};

export const getMetricLabel = (value, kind, labelKey = 'titleLabel') => {
  const metricOption = metricOptions[kind].find((option) => option.value === value) || {};
  return metricOption[labelKey] || metricOption.label;
};
